module.exports = __webpack_public_path__ + "static/media/bong.2d044818.svg";